import { Helmet } from "react-helmet-async";
import "./style.css";
import Screen from "../Layouts/Screen/Screen";
import ItemList from "../../components/ItemList/ItemList";

const About = () => {
  return (
    <>
      <Screen paddingTopTitle={true} title="Sobre o Paçoca">
        <Helmet>
          <title>Paçoca - Sobre o Paçoca</title>
          <meta name="description" content={`Paçoca - Sobre o Paçoca!`} />
          <meta name="keywords" content={`Paçoca, rede social brasileira, Sobre o Paçoca, selos, badges, sobre}`} />
          <meta name="author" content="Paçoca Inc." />
          <meta property="og:title" content={`Paçoca - Sobre o Paçoca - Rede Social`} />
          <meta property="og:description" content={`Paçoca - Sobre o Paçoca`} />
          <meta property="og:image" content="/img/link-preview.png?v=1" />
          <meta property="og:image:width" content="1200" />
          <meta property="og:image:height" content="630" />
          <meta property="og:url" content={window.location.href} />
          <meta property="og:type" content="website" />
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content={`Paçoca - Sobre o Paçoca - Rede Social`} />
          <meta name="twitter:description" content={`Paçoca - Sobre o Paçoca`} />
          <meta name="twitter:image" content="/img/link-preview.png?v=1" />
        </Helmet>

        <ItemList>
          <div className="col-12">
            Sobre
            <p style={{ marginTop: "5px" }}>
              Paçoca é uma rede social 100% brasileira criada por João Enrique
              Barbosa Santos Alves em 2023. Aos 17 anos, João estudava
              Desenvolvimento de Sistemas na ETEC da Zona Leste e buscava
              desenvolver um projeto útil que fosse além das atividades
              escolares. Inspirado pela ideia de criar uma plataforma de
              interação social, ele decidiu iniciar o desenvolvimento de uma
              rede social, programando sozinho desde o início até hoje.
            </p>
          </div>
        </ItemList>

        <ItemList>
          <div className="col-12">
            História
            <p style={{ marginTop: "5px" }}>
              O projeto foi desenvolvido de forma independente, idealizado e
              programado apenas pelo João, ao longo do tempo, aprimorado
              sempre que João tinha disponibilidade. A primeira versão do
              Paçoca foi lançada em um servidor gratuito. O crescimento
              inesperado da rede social aconteceu quando o Twitter/X sofreu uma
              instabilidade, levando João a divulgar o Paçoca no Facebook.
              Isso gerou um aumento expressivo no número de usuários,
              ocasionando a queda dos servidores devido ao alto tráfego.
            </p>
            <p style={{ marginTop: "5px" }}>
              Desde então, a equipe tem trabalhado na melhoria dos servidores e
              na otimização do código para suportar a crescente demanda de
              usuários. Em 2024, dois grandes colaboradores, Zack e Bochecha,
              juntaram-se ao projeto, trazendo novas ideias e contribuindo para
              o avanço da plataforma. Em 2025, Pixel tornou-se um membro
              fundamental, auxiliando significativamente na segurança do sistema
              e na migração para um servidor mais robusto.
            </p>
          </div>
        </ItemList>

        <ItemList>
          <div className="col-12">
            Expansão e desenvolvimento
            <p style={{ marginTop: "5px" }}>
              Atualmente, o Paçoca continua evoluindo, com constantes melhorias
              e ajustes técnicos para oferecer uma experiência mais estável e
              eficiente para seus usuários. O projeto segue ganhando
              notoriedade, e diferentes versões sobre sua origem têm sido
              divulgadas, contribuindo para a crescente repercussão da
              plataforma.
            </p>
            <p style={{ marginTop: "5px" }}>
              Em 2024 foi lançado a versão oficial do Paçoca em React Native
              para Android, e Windows, em breve disponível para iOS.
            </p>
          </div>
        </ItemList>

        <ItemList>
          <div className="col-12">
            Tecnologias Iniciais
            <p style={{ marginTop: "5px" }}>
              <b>Laravel e PHP:</b> O backend do Paçoca é desenvolvido em
              Laravel, um framework PHP que facilita a construção de aplicações
              web modernas e escaláveis. Laravel oferece uma sintaxe elegante e
              uma estrutura MVC (Model-View-Controller) que organiza o código de
              maneira eficiente, promovendo a separação de responsabilidades.
            </p>
            <p style={{ marginTop: "5px" }}>
              <b>MySQL:</b> Para o gerenciamento de dados, o Paçoca utiliza o
              MySQL, um sistema de gerenciamento de banco de dados relacional
              amplamente utilizado. MySQL permite o armazenamento eficiente de
              dados, bem como a realização de consultas complexas, garantindo a
              integridade e a segurança das informações.
            </p>
            <p style={{ marginTop: "5px" }}>
              <b>HTML/CSS:</b> O frontend da aplicação é desenvolvido em HTML e
              CSS, que são as tecnologias fundamentais para a construção de
              páginas web. HTML fornece a estrutura básica do conteúdo, enquanto
              o CSS é responsável pelo design e pela apresentação visual,
              permitindo que a aplicação tenha uma interface atraente e
              responsiva.
            </p>
            <p style={{ marginTop: "5px" }}>
              <b>JavaScript:</b> O JavaScript é utilizado para adicionar
              interatividade e dinamismo à aplicação. Com ele, é possível
              manipular o DOM, realizar validações de formulários e criar
              experiências de usuário mais envolventes.
            </p>
            <p style={{ marginTop: "5px" }}>
              <b>React Native:</b> O aplicativo do Paçoca para dispositivos
              Android e iOS é desenvolvido em React Native. Essa tecnologia
              permite criar aplicações nativas utilizando JavaScript e React,
              proporcionando um desempenho otimizado e uma experiência de
              usuário fluida em ambas as plataformas móveis.
            </p>
            <p style={{ marginTop: "5px" }}>
              <b>Electron:</b> Para as versões de desktop do Paçoca, que são
              compatíveis com Windows, Linux e macOS, a aplicação é desenvolvida
              em Electron. Essa plataforma permite a construção de aplicações
              desktop utilizando tecnologias web, como HTML, CSS e JavaScript,
              oferecendo uma interface consistente e funcionalidades nativas em
              múltiplos sistemas operacionais.
            </p>
            <p style={{ marginTop: "5px" }}>
              <b>Migração para React Em 01 de abril de 2025</b>, o frontend do
              Paçoca será migrado para o React, uma biblioteca JavaScript
              desenvolvida pelo Facebook. A migração para React visa melhorar a
              eficiência do desenvolvimento do frontend, permitindo a criação de
              componentes reutilizáveis e facilitando a gestão do estado da
              aplicação. Com React, o Paçoca poderá oferecer uma experiência de
              usuário ainda mais fluida e responsiva
            </p>
            <p style={{ marginTop: "5px" }}>
              Em 2024 foi lançado a versão oficial do Paçoca em React Native
              para Android, e Windows, em breve disponível para iOS.
            </p>
          </div>
        </ItemList>
      </Screen>
    </>
  );
};

export default About;
